import axiosInstance from "./AxiosConfig";
import {REST_API_BASE_URL_REMOTE} from '../services/PathEnvironment'

const REST_API_BASE_URL = REST_API_BASE_URL_REMOTE + 'api/category';

export const listCategory = () => axiosInstance.get(REST_API_BASE_URL);


